import request from '@/router/axios';

// 获取招商码 列表
/**
 * 
 * @param {String} current 
 * @param {String} size 
 * @param {Object} params 
 * @param {Object} search 
 * @returns 
 */
export const loanManagerCodeInfoPage = (current, size, params, search) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/page',
    method: 'post',
    data: {
      ...params,
      ...search,
      current,
      size
    }
  })
}

// 获取招商记录 列表
export const loanInvestmentInfoPage = (current, size, params, search) => {
  return request({
    url: '/api/blade-loanInvestmentInfo/loanInvestmentInfo/page',
    method: 'post',
    data: {
      ...params,
      ...search,
      current,
      size
    }
  })
}

// 查看代理商 列表
export const selectDeptByCode = (current, size,id) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/selectDeptByCode',
    method: 'get',
    params: {
      id,
      size,
      current,
    }
  })
}

// 招商经理二维码信息表 修改是否启用
export const update = (search) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/update',
    method: 'post',
    data: {
      ...search
    }
  })
}

// 新增 招商码
export const save = (search) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/save',
    method: 'post',
    data: {
      ...search
    }
  })
}

// 删除 招商码
export const remove = (params) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/remove',
    method: 'get',
    params: {
      id:params
    }
  })
}

// 换绑 招商码（编辑）
export const updateManage = (data) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/updateManage',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 解绑 招商码
export const updateDeptByCode = (data) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/updateDeptByCode',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 获取招生经理列表角色下拉
export const selectManagerRoleList = (roleId) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/selectManagerRoleList',
    method: 'get',
    params: {
      roleId: roleId || ''
    }
  })
}

// 新增时根据招商经理获取到角色id列表
export const selectRoleByManagerList = (userId) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/selectRoleByManagerIdList',
    method: 'get',
    params: {
      userId: userId || ''
    }
  })
}

// 获取招商码
export const getInvestmentQRCode = (code) => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/createCode',
    method: 'get',
    params: {
      code
    }
  })
}